<template>
  <div class="mt-3">
    <p class="block text-sm font-semibold text-gray-900">Risques à couvrir</p>
    <p class="mt-0.5 text-xs italic text-gray-600">
      Quels risques souhaitez-vous couvrir ? (plusieurs choix possibles)
    </p>
    <div class="flex gap-2 mt-2 flex-wrap">
      <button
        v-for="risk in options"
        :key="risk.value"
        type="button"
        :class="[
          'text-xs cursor-pointer flex items-center px-2.5 py-1.5 border-2 rounded-md shadow-xs focus:outline-hidden transition-colors duration-200 whitespace-nowrap shrink-0',
          modelValue.includes(risk.value)
            ? 'border-primary-dark bg-primary text-button-font-primary'
            : 'bg-white text-gray-700 hover:bg-primary-light hover:border-primary',
        ]"
        @click="toggleRisk(risk.value)"
      >
        {{ modelValue.includes(risk.value) ? "☑" : "☐" }} {{ $t(`advisory.risks.${risk.value}`) }}
      </button>
    </div>
    <div
      v-if="showConnectProtectionTheftAndBreakdownAlert"
      class="mt-2 p-2 rounded-md bg-blue-50 border border-blue-200 text-xs text-blue-800"
    >
      <span class="font-medium">ℹ️</span>
      Seules les formules
      <strong>OR</strong>
      et
      <strong>PLATINE</strong>
      couvrent les risques de vol et de panne.
    </div>
    <div
      v-if="showMobileProtectionBreakdownAlert"
      class="mt-2 p-2 rounded-md bg-blue-50 border border-blue-200 text-xs text-blue-800"
    >
      <span class="font-medium">ℹ️</span>
      La garantie panne (extension de garantie constructeur) n'est pas incluse dans l'offre
      <strong>Mobile Protection.</strong>
      Seuls les risques de casse, d'oxydation et de vol sont couverts.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    offerType: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    showConnectProtectionTheftAndBreakdownAlert() {
      if (this.offerType !== "connect_protection") return false;
      return this.modelValue.includes("theft") || this.modelValue.includes("breakdown");
    },
    showMobileProtectionBreakdownAlert() {
      return this.offerType === "mobile_protection" && this.modelValue.includes("breakdown");
    },
  },
  methods: {
    toggleRisk(value) {
      const risks = [...this.modelValue];
      const idx = risks.indexOf(value);
      if (idx >= 0) risks.splice(idx, 1);
      else risks.push(value);
      this.$emit("update:modelValue", risks);
    },
  },
};
</script>
